<template>
  <div class="electronic-over-view">
    <!--<el-tabs type="card" v-model="buildingOnPage">-->
    <!--<el-tab-pane v-for="buildItem in buildingList" :label="buildItem.name" :name="buildItem.code" :key="buildItem.code">-->

    <!--</el-tab-pane>-->

    <div class="electronic-over-view-line" style="margin-bottom: 0.12rem">
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgba(52, 147, 235, .8), rgba(54, 212, 233, .8));">
        <!--        <i class="el-icon-damai-dianbiaolixianshuaibaobiao"></i>-->
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">水表总数</div>
            <div class="electronic-person-count">{{waterMeterTotalCount || 0}}<span class="electronic-person-count-unit">(个)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_water/water_total.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgba(240, 152, 25, .8), rgba(237, 222, 93, .8));">
        <!--        <i class="el-icon-damai-dianbiaolixianshuaibaobiao"></i>-->
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">离线水表</div>
            <div class="electronic-person-count"><span :style="{color: waterMeterOffCount ? 'red' : '#fff'}">{{waterMeterOffCount || 0}}</span><span class="electronic-person-count-unit">(个)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_water/water_leave.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgba(255, 121, 121, .8), rgba(255, 167, 209, .8));">
        <!--        <i class="el-icon-damai-shebei2"></i>-->
        <div class="electronic-person-count-box-info" style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1">
            <div class="electronic-person-tip">集中器总数</div>
            <div class="electronic-person-count">{{waterManagerTotalCount || 0}}<span class="electronic-person-count-unit">(台)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_water/gather_total.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgba(141, 175, 255, .8), rgba(38, 208, 206, .8));">
        <!--        <i class="el-icon-damai-shebei2"></i>-->
        <div class="electronic-person-count-box-info" style="">
          <div style="flex: 1">
            <div class="electronic-person-tip">离线集中器</div>
            <div class="electronic-person-count"><span :style="{color: waterManagerOffCount ? 'red' : '#fff'}">{{waterManagerOffCount || 0}}</span><span class="electronic-person-count-unit">(台)</span></div>
          </div>
        </div>
        <img src="../../../assets/smart_water/gather_leave.png" alt="">
      </div>
      <div class="electronic-person-count-box" style="display: flex;justify-content: space-between;align-items: center;background:linear-gradient(to right, rgba(236, 104, 144, .8), rgba(161, 95, 228, .8));">
        <!--        <i class="el-icon-damai-liuliang"></i>-->
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-tip">当月水量</div>
          <div class="electronic-person-count" style="font-size: 0.15rem">{{waterQuantityTitle || 0}}<span class="electronic-person-count-unit">(吨)</span></div>
        </div>
        <img src="../../../assets/smart_water/water_num.png" alt="" style="width: 0.2rem;height: 0.3rem">
      </div>
      <div class="electronic-person-count-box" style="background:linear-gradient(to right, rgba(51, 201, 96, .8), rgba(43, 205, 205, .8))">
        <!--        <i class="el-icon-damai-yingshoujine"></i>-->
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-tip">当月水费</div>
          <div class="electronic-person-count" style="font-size: 0.15rem">{{waterFeiTitle || 0}}<span class="electronic-person-count-unit">(元)</span></div>
        </div>
        <img src="../../../assets/smart_water/water_charge.png" alt="">
      </div>
    </div>

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px">-->
    <!--        <div class="electronic-over-view-line-left">-->
    <!--          <common-ring commonRingId="ammeterRing" :height="'240px'" :colorList="['#44c23b', '#f54659']" :ringLegend="commonRingLegend" :ringTitle='ammeterTitle' :ringData='ammeterInfo' />-->
    <!--          <common-ring commonRingId="controllerRing" :height="'240px'" :colorList="['#44c23b', '#f54659']" :ringLegend="commonRingLegend" :ringTitle='controllerTitle' :ringData='controllerInfo' />-->
    <!--        </div>-->
    <!--        <div class="electronic-over-view-line-right">-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="waterQuantityRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='waterQuantityTitle' :ringData='waterQuantityInfo' />-->
    <!--          </div>-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="waterFeiRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='waterFeiTitle' :ringData='waterFeiInfo' />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);position: relative;">-->
    <!--        <div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--          <el-switch-->
    <!--            v-model="waterityRadio"-->
    <!--            active-text="年度"-->
    <!--            inactive-text="月度">-->
    <!--          </el-switch>-->
    <!--        </div>-->
    <!--        <common-line style="z-index: 1000" lineId='waterityLine' :height='"280px"' :lineTitle='waterityTitle' :legendData="waterityLegendData" :xAxis="waterityXAxis" :yAxis='waterityYAxis' :series='wateritySeries' />-->
    <!--      </div>-->

    <div class="electronic-over-view-line" style="margin-bottom: 0.12rem;padding: 0.12rem;position: relative;border-radius: 0.06rem;background-color: #fff;">
      <h2>级别水量统计</h2>
      <chart-time-select @getData="getWaterLevleStatistics" style="right: 0.14rem;top: 7.5%" />
      <common-line
        style="z-index: 1000"
        lineId='waterLevelLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendTextStyle="legendTextStyle"
        :legendData="waterLevelLegendData"
        :xAxis="waterLevelXAxis"
        :yAxis='waterLevelYAxis'
        :series='waterLevelSeries'
      />
    </div>

    <div class="electronic-over-view-line" style="margin-bottom: 0.12rem;padding: 0.12rem;position: relative;border-radius: 0.06rem;background-color: #fff;">
      <h2>场景水量统计</h2>
      <chart-time-select @getData="getWaterStatistics" style="right: 0.14rem;top: 7.5%" />
      <common-line
        style="z-index: 1000"
        lineId='waterLine'
        legendRight="478px"
        legendTop="2.7%"
        legendWidth="50%"
        legend-type="scroll"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendTextStyle="legendTextStyle"
        :legendData="waterLegendData"
        :xAxis="waterXAxis"
        :yAxis='waterYAxis'
        :series='waterSeries'
      />
    </div>

    <div class="electronic-over-view-line" style="padding: 0.12rem;position: relative;border-radius: 0.06rem;background-color: #fff;">
      <h2>充值统计</h2>
      <chart-time-select @getData="getWaterRechargeStatistics" style="right: 0.14rem;top: 7.5%" />
      <common-line
        style="z-index: 1000"
        lineId='waterityLine'
        legendRight="478px"
        legendTop="2.7%"
        gridLeft="1.7%"
        :height='"1.73rem"'
        :legendData="waterRechargeStatisticsLegendData"
        :xAxis="waterRechargeStatisticsXAxis"
        :yAxis='waterRechargeStatisticsYAxis'
        :series='waterRechargeStatisticsSeries'
      />
    </div>

    <!--<div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #eeeeee;border-radius: 10px;padding: 10px 10px;position: relative;">-->
    <!--<div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--<el-switch-->
    <!--v-model="waterityFeiLineRadio"-->
    <!--active-text="年度"-->
    <!--inactive-text="月度">-->
    <!--</el-switch>-->
    <!--</div>-->
    <!--<common-line style="z-index: 1000" lineId='waterityFeiLine' :height='"280px"' :lineTitle='waterityFeiLineTitle' :legendData="waterityFeiLineLegendData" :xAxis="waterityFeiLineXAxis" :yAxis='waterityFeiLineYAxis' :series='waterityFeiLineSeries' />-->
    <!--</div>-->

    <!--<div class="visitor-over-view-line" style="height: 300px;margin: 30px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">-->
    <!--<div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--<el-switch-->
    <!--v-model="waterityPayRadio"-->
    <!--active-text="年度"-->
    <!--inactive-text="月度">-->
    <!--</el-switch>-->
    <!--</div>-->
    <!--<common-line style="z-index: 1000" lineId='waterityPayLine' :height='"280px"' :lineTitle='waterityPayTitle' :legendData="waterityPayLegendData" :xAxis="waterityPayXAxis" :yAxis='waterityPayYAxis' :series='waterityPaySeries' />-->
    <!--</div>-->

    <!--<div class="electronic-over-view-line">-->
    <!--<div class="electronic-over-view-line-left" style="justify-content: flex-start;flex-direction: column;height: 270px;display: block">-->
    <!--<div style="display: flex;justify-content: space-between">-->
    <!--<div>欠费住户 ({{arrearsTotal}})</div>-->
    <!--<el-pagination-->
    <!--@current-change="arrearsCurrentChange"-->
    <!--:page-size="arrearsPageSize"-->
    <!--layout="prev, pager, next"-->
    <!--:total="arrearsTotal">-->
    <!--</el-pagination>-->
    <!--</div>-->
    <!--<el-table-->
    <!--:data="arrearsTableData"-->
    <!--style="width: 100%">-->
    <!--<el-table-column-->
    <!--label="住户名称">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="房间号">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.roomName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="余额(元)">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentBalance }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="联系人"-->
    <!--width="180">-->
    <!--<template slot-scope="scope">-->
    <!--<el-popover trigger="hover" placement="top">-->
    <!--<p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
    <!--<p v-else>暂无联系人</p>-->
    <!--<div slot="reference" class="name-wrapper">-->
    <!--<span style="color: #00a0e6">联系人</span>-->
    <!--&lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
    <!--</div>-->
    <!--</el-popover>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--</el-table>-->
    <!--</div>-->
    <!--<div class="electronic-over-view-line-right" style="justify-content: flex-start;flex-direction: column;height: 270px">-->
    <!--<div style="display: flex;justify-content: space-between">-->
    <!--<div>余额不足住户 ({{approachingPaymentTotal}})</div>-->
    <!--<el-pagination-->
    <!--@current-change="approachingPaymentCurrentChange"-->
    <!--:page-size="approachingPaymentPageSize"-->
    <!--layout="prev, pager, next"-->
    <!--:total="approachingPaymentTotal">-->
    <!--</el-pagination>-->
    <!--</div>-->
    <!--<el-table-->
    <!--:data="approachingPaymentTableData"-->
    <!--style="width: 100%">-->
    <!--<el-table-column-->
    <!--label="住户名称">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="房间号">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.roomName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="余额(元)">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentBalance }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="联系人"-->
    <!--width="180">-->
    <!--<template slot-scope="scope">-->
    <!--<el-popover trigger="hover" placement="top">-->
    <!--<p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
    <!--<p v-else>暂无联系人</p>-->
    <!--<div slot="reference" class="name-wrapper">-->
    <!--<span style="color: #00a0e6">联系人</span>-->
    <!--&lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
    <!--</div>-->
    <!--</el-popover>-->
    <!--</template>-->
    <!--</el-table-column>-->

    <!--</el-table>-->
    <!--</div>-->
    <!--</div>-->

  </div>
</template>

<script>
import { api } from "../../api/WaterManagement";
import { errorHandler } from "../../../utils/errorHandler";
import ControllerPie from "../../../components/Echarts/Pie/Pie/controllerPie";
import AmmeterPie from "../../../components/Echarts/Pie/Pie/ammeterPie";
import ElectronicStackingBar from "../../../components/Echarts/Bar/StackingBar/ElectronicStackingBar";
import ElectronicMonthStackingBar from "../../../components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar";
import CommonLine from "../../../components/Echarts/Line/commonLine";
import CommonRing from "../../../components/Echarts/Pie/Pie/commonRing";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/newChartTimeSelect";
import {debounce} from '../../../utils/util'

export default {
  components: {
    ChartTimeSelect,
    CommonRing,
    CommonLine,
    ElectronicMonthStackingBar,
    ElectronicStackingBar,
    AmmeterPie,
    ControllerPie
  },
  name: "over-view",
  data() {
    return {
      waterSceneList: [],
      // 楼栋
      buildingOnPage: "",
      buildingList: [],

      waterLevelTitle: "级别水量统计",
      waterLevelLegendData: [],
      waterLevelXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      waterLevelYAxis: [
        {
          type: "value",
          name: "水量(吨)",
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      waterLevelSeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      waterRadio: false,
      waterTitle: "场景水量统计",
      waterLegendData: [],
      waterXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      waterYAxis: [
        {
          type: "value",
          name: "水量(吨)",
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      waterSeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      commonColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC"
      ],
      commonRingLegend: {
        left: "center",
        bottom: -5
      },
      ammeterTitle: "水表",
      ammeterInfo: [],
      controllerTitle: "控制器",
      controllerInfo: [],
      waterQuantityTitle: "",
      waterQuantityInfo: [],
      waterFeiTitle: "",
      waterFeiInfo: [],

      // 欠费住户
      arrearsPageNum: 1,
      arrearsPageSize: 5,
      arrearsTotal: 0,
      arrearsTableData: [],

      // 临近缴费住户
      approachingPaymentPageNum: 1,
      approachingPaymentPageSize: 5,
      approachingPaymentTotal: 0,
      approachingPaymentTableData: [],

      waterityRadio: false,
      waterityTitle: "水量统计",
      waterityLegendData: [],
      waterityXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      waterityYAxis: [
        {
          type: "value",
          name: "用水量(吨)",
          splitLine: {
            show: false
          }
        }
      ],
      wateritySeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      waterRechargeStatisticsTitle: "充值统计",
      waterRechargeStatisticsLegendData: [],
      waterRechargeStatisticsXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        boundaryGap: false,
        axisTick: {
          show: false, //是否显示刻度
        },
        axisLabel: {
          color: '#000',
          fontSize: 'calc(100vw * 14/ 1920)',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'dotted',
            color: 'rgba(50,50,50,0.4)',//坐标线的颜色
          }
        },
        data: []
      },
      waterRechargeStatisticsYAxis: [
        {
          type: "value",
          name: "金额(元)",
          nameTextStyle: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          axisTick: {
            show: false, //是否显示刻度
          },
          axisLabel: {
            color: '#000',
            fontSize: 'calc(100vw * 14/ 1920)',
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(50,50,50,0.4)',//坐标线的颜色
            }
          },
        }
      ],
      waterRechargeStatisticsSeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],
      legendTextStyle: {
        fontSize: 'calc(100vw * 14/ 1920)',
      },
      waterityFeiLineRadio: false,
      waterityFeiLineTitle: "水费统计",
      waterityFeiLineLegendData: [],
      waterityFeiLineXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      waterityFeiLineYAxis: [
        {
          type: "value",
          name: "金额(元)",
          splitLine: {
            show: false
          }
        }
      ],
      waterityFeiLineSeries: [
        {
          name: "",
          type: "line",
          stack: "统计",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6"
              },
              {
                offset: 1,
                color: "#ffe"
              }
            ])
          },
          data: []
        }
      ],

      waterityPayRadio: false,
      waterityPayTitle: "充值统计",
      waterityPayLegendData: [],
      waterityPayXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      waterityPayYAxis: [
        {
          type: "value",
          name: "金额(元)",
          splitLine: {
            show: false
          }
        }
      ],
      waterityPaySeries: [],

      waterMeterTotalCount: 0,
      waterMeterOffCount: 0,

      waterManagerTotalCount: 0,
      waterManagerOffCount: 0,

      waterFeiLineLegendData: [],
      waterFeiLineXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      idList: ['waterLevelLine', 'waterLine', 'waterityLine']
    };
  },
  created() {
    // this.getBuildingList()
    // this.getArrearsList()
    // this.getApproachingPaymentList()
    // this.getRechargeStatistics(1)
    this.getWaterityStatistics(1);
    this.getCurrentMonthWaterity();
    this.getWaterMeterDeviceOverview();
    this.getWaterControlDeviceOverview();
    this.getWaterSceneList();
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    resizeChart: debounce(function () {
      this.idList.map(v =>{
        let commonLine = this.$echarts.init(document.getElementById(v));
        commonLine.resize()
      })
    }, 100),

    // 获取楼栋列表
    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.unshift({
              code: "",
              name: "全部"
            });
            this.buildingList = data;
          }
        })
        .catch(errorHandler("获取楼栋列表失败"));
    },

    // 水表
    getWaterMeterDeviceOverview() {
      this.$axios
        .post(api.getWaterMeterDeviceOverview, {})
        .then(res => {
          let data = res.data.data;
          let onLine = { value: data.onlineCount || 0, name: "在线" };
          let offLine = { value: data.offlineCount || 0, name: "离线" };
          this.ammeterInfo = [onLine, offLine];
          this.ammeterTitle = `水表(${data.totalCount})`;

          this.waterMeterTotalCount = data.totalCount;
          this.waterMeterOffCount = data.offlineCount;
        })
        .catch(errorHandler("获取水表数据失败"));
    },

    // 集中器
    getWaterControlDeviceOverview() {
      this.$axios
        .post(api.getWaterControlDeviceOverview, {})
        .then(res => {
          let data = res.data.data;
          let onLine = { value: data.onlineCount || 0, name: "在线" };
          let offLine = { value: data.offlineCount || 0, name: "离线" };
          this.controllerInfo = [onLine, offLine];
          this.controllerTitle = `控制器(${data.totalCount})`;

          this.waterManagerTotalCount = data.totalCount;
          this.waterManagerOffCount = data.offlineCount;
        })
        .catch(errorHandler("获取集中器数据失败"));
    },

    getWaterRechargeStatistics(type, startTime, endTime) {
      this.$axios
        .post(`${api.getWaterRechargeStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let seriesData = [];
          data.map(v => {
            seriesData.push(v.waterInvoicingMoney);
            xData.push(v.time);
          });
          this.waterRechargeStatisticsXAxis.data = xData;
          this.waterRechargeStatisticsSeries = [
            {
              name: "",
              type: "line",
              // stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#0A84FF"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(10, 132, 255, 0.40)"
                  },
                  {
                    offset: 1,
                    color: "rgba(10, 132, 255, 0)"
                  }
                ])
              },
              data: seriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 欠费
    arrearsCurrentChange(val) {
      this.arrearsPageNum = val;
      this.getArrearsList();
    },

    // 获取欠费住户
    getArrearsList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: "1",
          pageNum: this.arrearsPageNum,
          pageSize: this.arrearsPageSize
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.arrearsTableData = data.list;
            this.arrearsTotal = data.total;
          }
        })
        .catch(errorHandler("获取欠费住户失败"));
    },

    // 欠费
    approachingPaymentCurrentChange(val) {
      this.approachingPaymentPageNum = val;
      this.getApproachingPaymentList();
    },

    // 获取临近缴费住户
    getApproachingPaymentList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: "2",
          pageNum: this.approachingPaymentPageNum,
          pageSize: this.approachingPaymentPageSize
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.approachingPaymentTableData = data.list;
            this.approachingPaymentTotal = data.total;
          }
        })
        .catch(errorHandler("获取临近缴费住户失败"));
    },

    getCurrentMonthWaterity() {
      this.$axios
        .get(`${api.getCurrentMonthWaterity}`, {})
        .then(res => {
          let details = res.data.data.details;
          let waterQuantityInfo = [];
          let waterFeiInfo = [];
          let allQuantity = 0;
          let allMoney = 0;
          if (details) {
            details.map(v => {
              let waterQuantityObj = {
                name: v.waterSceneName,
                value: v.waterSceneData
              };
              let waterFeiObj = {
                name: v.waterSceneName,
                value: v.waterSceneMoney
              };
              allQuantity = parseFloat(allQuantity + v.waterSceneData).toFixed(
                2
              );
              allMoney = parseFloat(allMoney + v.waterSceneMoney).toFixed(2);
              waterQuantityInfo.push(waterQuantityObj);
              waterFeiInfo.push(waterFeiObj);
            });
          }
          this.waterQuantityInfo = waterQuantityInfo;
          this.waterQuantityTitle = `${res.data.data.totalWaterity && String(res.data.data.totalWaterity).indexOf('.') > -1 ? res.data.data.totalWaterity.toFixed(0) : res.data.data.totalWaterity}`;
          this.waterFeiInfo = waterFeiInfo;
          this.waterFeiTitle = `${res.data.data.totalMoney && String(res.data.data.totalMoney).indexOf('.') > -1 ? res.data.data.totalMoney.toFixed(0) : res.data.data.totalMoney}`;
        })
        .catch(errorHandler("获取数据失败"));
    },

    getRechargeStatistics(type) {
      this.$axios
        .get(`${api.getRechargeStatistics}/${type}`, {})
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let seriesData = [];
          data.map(v => {
            seriesData.push(v.money);
            if (type === 1) {
              let dateArr = v.date.split("-");
              let showData = `${dateArr[1]}-${dateArr[2]}`;
              xData.push(showData);
            } else {
              xData.push(v.date);
            }
          });
          this.waterityPayXAxis.data = xData;
          this.waterityPaySeries = [
            {
              name: "",
              type: "line",
              stack: "统计",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#00A0E6"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00A0E6"
                  },
                  {
                    offset: 1,
                    color: "#ffe"
                  }
                ])
              },
              data: seriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 水量统计
    getWaterityStatistics(type, str) {
      let colorList = [
        "#5B9BD5",
        "#ED7D31",
        "#FFC000",
        "#A5A5A5",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC"
      ];
      this.$axios
        .get(`${api.getWaterityStatistics}/${type}`, {})
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let wateritySeriesData = [];
          let waterityFeiLineSeriesData = [];
          let waterityNameData = [];
          let wateritySeries = [];
          let waterityFeiLineSeries = [];
          data.map((v, i) => {
            if (v.details) {
              if (i === 0) {
                v.details.map(detail => {
                  waterityNameData.push(detail.waterSceneName);
                });
              }
              v.details.map((detail, detailIndex) => {
                if (!wateritySeriesData[detailIndex]) {
                  wateritySeriesData[detailIndex] = [];
                }
                wateritySeriesData[detailIndex].push(detail.waterSceneData);
                if (!waterityFeiLineSeriesData[detailIndex]) {
                  waterityFeiLineSeriesData[detailIndex] = [];
                }
                waterityFeiLineSeriesData[detailIndex].push(
                  detail.waterSceneMoney
                );
              });
              if (type === 1) {
                let dateArr = v.billTime.split("-");
                let showData = `${dateArr[1]}-${dateArr[2]}`;
                xData.push(showData);
              } else {
                xData.push(v.billTime);
              }
            }
          });
          if (data.length > 0) {
            if (data[0].details) {
              for (let k = 0; k < data[0].details.length; k++) {
                wateritySeries[k] = {
                  name: data[0].details[k].waterSceneName,
                  type: "line",
                  stack: "统计",
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: colorList[k]
                        },
                        {
                          offset: 1,
                          color: "#ffe"
                        }
                      ]
                    )
                  },
                  data: wateritySeriesData[k]
                };
                waterityFeiLineSeries[k] = {
                  name: data[0].details[k].waterSceneName,
                  type: "line",
                  // stack: "统计",
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: colorList[k]
                        },
                        {
                          offset: 1,
                          color: "#ffe"
                        }
                      ]
                    )
                  },
                  data: waterityFeiLineSeriesData[k]
                };
              }
            }
          }

          if (str === "waterity") {
            this.waterityXAxis.data = xData;
            this.waterityLegendData = waterityNameData;
            this.wateritySeries = wateritySeries;
          } else if (str === "waterityFeiLine") {
            this.waterityFeiLineXAxis.data = xData;
            this.waterityFeiLineLegendData = waterityNameData;
            this.waterityFeiLineSeries = waterityFeiLineSeries;
          } else {
            this.waterityXAxis.data = xData;
            this.waterityFeiLineXAxis.data = xData;
            this.wateritySeries = wateritySeries;
            this.waterityFeiLineSeries = waterityFeiLineSeries;
            this.waterityLegendData = waterityNameData;
            this.waterityFeiLineLegendData = waterityNameData;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 级别水量统计
    getWaterLevleStatistics(type, startTime, endTime) {
      let colorList = [
        "#FF0A8E",
        "#8438FF",
        "#FF8C38",
        "#0A84FF",
        "#32D74B",
      ];
      let gradientColorList = [
        ["rgba(255, 10, 142, 0.40)", "rgba(255, 10, 142, 0)"],
        ["rgba(132, 56, 255, 0.40)", "rgba(132, 56, 255, 0)"],
        ["rgba(255, 140, 56, 0.40)", "rgba(255, 140, 56, 0)"],
        ["rgba(10, 132, 255, 0.40)", "rgba(10, 132, 255, 0)"],
        ["rgba(50, 215, 75, 0.40)", "rgba(50, 215, 75, 0)"],
      ];
      this.$axios
        .post(`${api.getWaterLevelStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let waterSeriesData = [];
          let waterNameData = ["一级", "二级", "三级", "四级", "五级"];
          let waterSeries = [];

          setTimeout(() => {
            data.map((v, i) => {
              waterNameData.map((waterName, waterNameIndex) => {
                if (!waterSeriesData[waterNameIndex]) {
                  waterSeriesData[waterNameIndex] = [];
                }
                if (v.waterDetails) {
                  v.waterDetails.map((detail, detailIndex) => {
                    if (!waterSeriesData[waterNameIndex][i]) {
                      waterSeriesData[waterNameIndex][i] = 0;
                    }
                    if (detail.level === waterNameIndex + 1) {
                      waterSeriesData[waterNameIndex][i] = detail.waterCommon;
                    }
                  });
                } else {
                  waterSeriesData[waterNameIndex][i] = 0;
                }
              });
              xData.push(v.time);
            });
            if (data.length > 0) {
              for (let k = 0; k < waterNameData.length; k++) {
                waterSeries[k] = {
                  name: waterNameData[k],
                  type: "line",
                  // stack: "统计",
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: gradientColorList[k][0]
                        },
                        {
                          offset: 1,
                          color: gradientColorList[k][1]
                        }
                      ]
                    )
                  },
                  data: waterSeriesData[k]
                };
              }
            }
            this.waterLevelLegendData = waterNameData;
            this.waterLevelXAxis.data = xData;
            this.waterLevelSeries = waterSeries;
          }, 50);
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取场景列表
    getWaterSceneList() {
      this.$axios
        .post(api.getWaterSceneList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.waterSceneList = data;
          }
        })
        .catch(errorHandler("获取场景列表失败"));
    },

    // 场景水量统计
    getWaterStatistics(type, startTime, endTime) {
      let colorList = [
        "#0A84FF",
        "#32D74B",
        "#FF9F0A",
        "#FF2D55",
        "#5E5CE6",
        "#FFD60A",
        "#FF453A",
        "#64D2FF",
        "#BF5AF2",
        "#D4DEEC",
      ];
      let gradientColorList = [
        ["rgba(10, 132, 255, 0.40)", "rgba(10, 132, 255, 0)"],
        ["rgba(50, 215, 75, 0.40)", "rgba(50, 215, 75, 0)"],
        ["rgba(255, 159, 10, 0.40)", "rgba(255, 159, 10, 0)"],
        ['rgba(255, 45, 85, 0.40)', 'rgba(255, 45, 85, 0)'],
        ["rgba(94, 92, 230, 0.40)", "rgba(94, 92, 230, 0)"],
        ["rgba(255, 214, 10, 0.40)", "rgba(255, 214, 10, 0)"],
        ["rgba(255, 69, 58, 0.40)", "rgba(255, 69, 58, 0)"],
        ["rgba(100, 210, 255, 0.40)", "rgba(100, 210, 255, 0)"],
        ["rgba(191, 90, 242, 0.40)", "rgba(191, 90, 242, 0)"],
        ['rgba(212, 222, 236, 0.40)', 'rgba(212, 222, 236, 0)'],
      ];
      this.$axios
        .post(`${api.getWaterStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY"
        })
        .then(res => {
          let data = res.data.data;
          let xData = [];
          let waterSeriesData = [];
          let waterFeiLineSeriesData = [];
          let waterNameData = [];
          let waterSeries = [];
          let waterFeiLineSeries = [];
          this.waterSceneList.map(v => {
            waterNameData.push(v.name);
          });
          setTimeout(() => {
            data.map((v, i) => {
              waterNameData.map((waterName, waterNameIndex) => {
                if (!waterSeriesData[waterNameIndex]) {
                  waterSeriesData[waterNameIndex] = [];
                }
                if (!waterFeiLineSeriesData[waterNameIndex]) {
                  waterFeiLineSeriesData[waterNameIndex] = [];
                }
                if (v.details) {
                  v.details.map((detail, detailIndex) => {
                    if (!waterSeriesData[waterNameIndex][i]) {
                      waterSeriesData[waterNameIndex][i] = 0;
                      waterFeiLineSeriesData[waterNameIndex][i] = 0;
                    }
                    if (detail.waterSceneName === waterName) {
                      console.log(detail);
                      waterSeriesData[waterNameIndex][i] =
                        detail.waterSceneData;
                      waterFeiLineSeriesData[waterNameIndex][i] =
                        detail.waterSceneMoney;
                    }
                  });
                } else {
                  waterSeriesData[waterNameIndex].push(0);
                  waterFeiLineSeriesData[waterNameIndex].push(0);
                }
              });
              if (type === 1) {
                let dateArr = v.billTime.split("-");
                let showData = `${dateArr[1]}-${dateArr[2]}`;
                xData.push(showData);
              } else {
                xData.push(v.billTime);
              }
            });
            if (data.length > 0) {
              for (let k = 0; k < waterNameData.length; k++) {
                waterSeries[k] = {
                  name: waterNameData[k],
                  type: "line",
                  // stack: "统计",
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: k > 9 ? colorList[k%10] : colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: k > 9 ? gradientColorList[k%10][0] : gradientColorList[k][0]
                        },
                        {
                          offset: 1,
                          color: k > 9 ? gradientColorList[k%10][1] : gradientColorList[k][1]
                        }
                      ]
                    )
                  },
                  data: waterSeriesData[k]
                };
                waterFeiLineSeries[k] = {
                  name: waterNameData[k],
                  type: "line",
                  stack: waterNameData[k],
                  // areaStyle: {},
                  smooth: true,
                  symbol: "circle",
                  symbolSize: 5,
                  sampling: "average",
                  itemStyle: {
                    color: colorList[k]
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: colorList[k]
                        },
                        {
                          offset: 1,
                          color: "#ffe"
                        }
                      ]
                    )
                  },
                  data: waterFeiLineSeriesData[k]
                };
              }
            }
            setTimeout(() => {
              this.waterXAxis.data = xData;
              this.waterFeiLineXAxis.data = xData;
              this.waterSeries = waterSeries;
              this.waterFeiLineSeries = waterFeiLineSeries;
              this.waterLegendData = waterNameData;
              this.waterFeiLineLegendData = waterNameData;
            }, 50);
          }, 50);
        })
        .catch(errorHandler("获取数据失败"));
    }
  },

  watch: {
    // waterityPayRadio (val) {
    //   if (!val) {
    //     this.getRechargeStatistics(1)
    //   } else {
    //     this.getRechargeStatistics(2)
    //   }
    // },
    // waterityRadio (val) {
    //   if (!val) {
    //     this.getEwaterityStatistics(1, 'waterity')
    //   } else {
    //     this.getEwaterityStatistics(2, 'waterity')
    //   }
    // },
    // waterityFeiLineRadio (val) {
    //   if (!val) {
    //     this.getEwaterityStatistics(1, 'waterityFeiLine')
    //   } else {
    //     this.getEwaterityStatistics(2, 'waterityFeiLine')
    //   }
    // }
  }
};
</script>

<style lang="less" scoped>
.electronic-over-view {
  padding: 0.16rem 0.12rem 0.16rem 0.16rem;
  background-color: rgba(240, 240, 247, 1);
  margin: 0;
  h2 {
    position: absolute;
    top: 6.2%;
    font-size: 0.1rem;
    text-align: left;
    z-index: 1001;
  }
  .electronic-over-view-line {
    display: flex;
    justify-content: space-between;
    .electronic-person-count-box {
      width: 1.3rem;
      height: 0.72rem;
      padding: 0.16rem 0.12rem;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00a0e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: unset;
      box-shadow: unset;
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      i {
        width: 30%;
        font-size: 48px;
      }
      .electronic-person-count-box-info {
        width: 70%;
        text-align: left;
        .electronic-person-count {
          font-size: 0.17rem;
          font-weight: 500;
          word-wrap: break-word;
          .electronic-person-count-unit {
            font-size: 0.08rem;
          }
        }
        .electronic-person-tip {
          font-size: 0.09rem;
          margin-bottom: 0.08rem;
        }
      }
    }
    .electronic-over-view-line-left {
      width: 49%;
      padding: 0.12rem 0.12rem 0 0.12rem;
      border-radius: 0.06rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }
    .electronic-over-view-line-right {
      width: 49%;
      padding: 0.12rem 0.12rem 0 0.12rem;
      border-radius: 0.06rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }

    //.el-table {
    //  thead {
    //    th {
    //      padding: 6px 0;
    //      text-align: center;
    //      color: #666666;
    //      background-color: #eff1f5;
    //    }
    //  }
    //  tbody {
    //    td {
    //      padding: 6px 0;
    //      text-align: center;
    //      color: #ff0000;
    //    }
    //  }
    //}
    //
    //.el-pagination {
    //  padding: 0;
    //}
  }
  /deep/.chart-time-select {
    margin: 0;
    width: unset;
    left: unset;
  }
  /deep/.chart-time-select1 {
    margin: 0;
    width: unset;
    left: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/OverView/OverView.vue